// The folder view's search: a case- and accent-insensitive substring match on the listed entries' names.

import {stripDiacritics} from './naming';

/**
 * The form names and queries are compared in: lowercase, without accents, and with `_` and `-` read as
 * spaces, since folder slugs and file names stand them for spaces ("jeges est" finds "20260114_jeges_est").
 */
export function normalizeSearchText(text: string): string {
    return stripDiacritics(text).toLowerCase().replace(/[\s_-]+/g, ' ').trim();
}

/** Whether the query narrows anything (blank queries don't). */
export function isSearchActive(query: string): boolean {
    return normalizeSearchText(query) !== '';
}

/** The entries whose name contains the query, in their original order. */
export function searchByName<T extends { name: string }>(entries: readonly T[], query: string): T[] {
    const needle = normalizeSearchText(query);
    if (!needle) return [...entries];
    return entries.filter((entry) => normalizeSearchText(entry.name).includes(needle));
}
